import { ENV } from "../constants";
import { PappaSquatException } from "../models/pappaSquatExceptionModel";
import { backendPublicRequest } from "./backendTransport";
import { backendRequest } from "./backendApi";
const serialize = (e: any) => ({
  message: e?.message || String(e),
  stack: e?.stack,
  details: e?.details,
  hint: e?.hint,
  code: e?.code,
});
const exceptionService = {
  async logError(
    error: any,
    module: string,
    userId?: string,
    deviceInfo?: string
  ): Promise<Boolean> {
    try {
      await backendPublicRequest("/exceptions/log", {
        error: serialize(error),
        module,
        userId,
        deviceInfo,
        environment: ENV.NODE_ENV,
        reportingOs: "host portal browser",
      });
    } catch {}
    return true;
  },
  async fetchExceptions(
    isMaintenanceWorker?: boolean,
    userId?: string
  ): Promise<PappaSquatException[]> {
    if (!isMaintenanceWorker) return [];
    const r = await backendRequest<PappaSquatException[]>("/exceptions/list");
    if (r.error) console.debug(r.error, userId);
    return r.data ?? [];
  },
  async updateExceptionResolved(
    recordId: string,
    isResolved: boolean,
    isMaintenanceWorker?: boolean
  ): Promise<Boolean> {
    if (!isMaintenanceWorker) return false;
    const r = await backendRequest<boolean>("/exceptions/update-resolved", {
      recordId,
      isResolved,
    });
    return r.data === true;
  },
};
export default exceptionService;
